import { render, staticRenderFns } from "./attendanceListwg.vue?vue&type=template&id=2bb432ea&scoped=true&"
import script from "./attendanceListwg.vue?vue&type=script&lang=js&"
export * from "./attendanceListwg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb432ea",
  null
  
)

export default component.exports